export const copyToClipboard = (targetId) => {
	const range = document.createRange()
	range.selectNode(document.getElementById(targetId))
	window.getSelection().removeAllRanges()
	window.getSelection().addRange(range)
	document.execCommand('copy')
	window.getSelection().removeAllRanges()
}
